import { useEffect, useState } from 'react';
import { UseContainerDimensionsReturn } from '../types';

// 🎯 Hook para manejar dimensiones del contenedor - SRP
export const useContainerDimensions = (
    containerRef: React.RefObject<HTMLDivElement | null>
): UseContainerDimensionsReturn => {
    const [dimensions, setDimensions] = useState<UseContainerDimensionsReturn>({
        width: 0,
        height: 0,
    });

    useEffect(() => {
        const updateDimensions = () => {
            if (containerRef.current) {
                const { clientWidth, clientHeight } = containerRef.current;
                setDimensions({
                    width: clientWidth,
                    height: clientHeight
                });
            }
        };

        // 🎯 Initial measurement
        updateDimensions();

        // 🎯 ResizeObserver para tracking en tiempo real
        let resizeObserver: ResizeObserver | null = null;

        if (containerRef.current && typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(updateDimensions);
            resizeObserver.observe(containerRef.current);
        }

        // 🎯 Fallback con window resize
        const handleWindowResize = () => {
            setTimeout(updateDimensions, 100); // Debounce
        };

        window.addEventListener('resize', handleWindowResize);

        return () => {
            if (resizeObserver) {
                resizeObserver.disconnect();
            }
            window.removeEventListener('resize', handleWindowResize);
        };
    }, [containerRef]);

    return dimensions;
}; 